import userImg from "../../../assets/images/user.svg";
import { useToggle } from "../../../hooks/common";
import {
  useAllApplicationReviews,
  useResubmissionReview,
} from "../../../hooks/resubmission.hooks";
import { formatDate } from "../../../utils/date";
import { RenderAllReviews } from "../../LevelTwo/RenderAllReviews";

export default function ResubmissionHeader({
  applicationId,
}: {
  applicationId: number;
}) {
  const [reviewDialog, toggleReviewDialog] = useToggle();
  const allReviewsQuery = useAllApplicationReviews({ id: applicationId });

  const { data: review } = useResubmissionReview(applicationId);

  if (!review) return null;

  return (
    <>
      <h4 className="text-center text-grey-600 font-semibold mb-8 text-lg md:text-2xl">
        Application Review
      </h4>
      <div className="flex justify-end">
        <button
          type="button"
          className="text-xs md:text-base font-bold disabled:text-gray-500"
          disabled={!allReviewsQuery.data?.length}
          onClick={toggleReviewDialog}
        >
          <i className="fa fa-history"></i>
          Previous Reviews
        </button>
      </div>
      <hr className="my-4" />
      <div className="flex justify-between gap-4 mb-4">
        <div className="basis-auto flex shrink-0 flex-col items-center">
          <img
            src={userImg}
            className="h-10 w-10 md:h-16 md:w-16"
            alt="profile-pic"
          />
        </div>
        <div className="grow px-1 py-1">
          <div className="flex justify-between mb-2 flex-col-reverse sm:flex-row">
            <h6 className="text-sm md:text-lg font-bold">
              {review.reviewer?.name || "--"}
              <span className="font-normal inline-block ml-4">
                {review?.reviewer?.role || ""}
              </span>
            </h6>
            <h6 className="text-sm md:text-base font-bold">
              {`Date - ${formatDate(review.date || "")}`}
            </h6>
          </div>
          <p style={{ textAlign: "left" }}>{review.comment_text}</p>
        </div>
      </div>
      {reviewDialog && (
        <RenderAllReviews
          onClose={toggleReviewDialog}
          reviews={allReviewsQuery.data ?? []}
        />
      )}
    </>
  );
}
